<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'ApplicationCenter',
            to: {
              name: 'ApplicationCenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'ApplicationEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改Application</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 修改Application -->
    <ApplicationCreateEdit></ApplicationCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>

    <!-- PageMenu -->
    <div class="block">
      <PageMenu :sections="sections">
        <component :is="sectionView"></component>
      </PageMenu>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import PageMenu from '@/components/PageMenu.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import TabTech from '@/views/B-13__ApplicationDetail/c/ApplicationTechnology.vue';
import TabProd from '@/views/B-13__ApplicationDetail/c/ApplicationProduct.vue';
import TabVideo from '@/views/B-13__ApplicationDetail/c/ApplicationVideo.vue';
import TabEdm from '@/views/B-13__ApplicationDetail/c/ApplicationEdm.vue';
import TabSuccessCase from '@/views/B-13__ApplicationDetail/c/ApplicationSuccessCase.vue';
import ApplicationCreateEdit from '@/views/B-13__ApplicationDetail/c/ApplicationCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    PageMenu,
    TabTech,
    TabProd,
    TabVideo,
    TabEdm,
    TabSuccessCase,
    ApplicationCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
    sections: [
      { name: 'Tech', component: 'TabTech' },
      { name: 'Prod', component: 'TabProd' },
      { name: 'Video', component: 'TabVideo' },
      { name: 'Insights', component: 'TabEdm' },
      { name: 'Success Cases', component: 'TabSuccessCase' },
    ],
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('application', ['application']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    if (this.$route.params.id) {
      await this.getApplication(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('application', {
      getApplication: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'ApplicationCenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.application.title) {
            this.errors.push('標題 required.');
          } else if (!this.application.detail_page_title) {
            this.errors.push('Detail Page Title required.');
          } else if (!this.application.cover_photo) {
            this.errors.push('Cover Photo required.');
          } else if (!this.application.content) {
            this.errors.push('content required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.application).then(() => {
            this.$router.push({ name: 'ApplicationCenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
